import Swiper from 'swiper/dist/js/swiper.min';

export function sliders($this) {
	$this.each((i, elem) => {
		let sliderId = $(elem).attr('id');
		let $slider = $(`#${sliderId}`);
		let sliderArrows = $slider.data('arrows');
		let sliderScrollbar = $slider.data('scrollbar');
		let showSlides = $slider.data('show-slides') || 3;
		let slidesCount = $slider.find('.slider__item').length;
		let prevNavTemp = `<button class="${sliderArrows} ${sliderArrows}--prev" aria-label="Следущюший" type="button"><svg width="15" height="15"><use xlink:href="svg-symbols.svg#icon-arrow-right-big"></use></svg></button>`;
		let nextNavTemp = `<button class="${sliderArrows} ${sliderArrows}--next" aria-label="Предыдущий" type="button"><svg width="15" height="15"><use xlink:href="svg-symbols.svg#icon-arrow-right-big"></use></svg></button>`;

		$slider.addClass('swiper-container swiper-slider');
		$slider.find('.swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');

		if (sliderArrows) {
			$slider.prepend(prevNavTemp);
			$slider.append(nextNavTemp);
		}

		let swiperSlider = new Swiper($slider, {
			slidesPerView: showSlides,
			navigation: sliderArrows ? {
				nextEl: `.${sliderArrows}--next`,
				prevEl: `.${sliderArrows}--prev`,
			} : false,
			scrollbar: sliderScrollbar ? {
				hide: false,
				draggable: true,
				el: `.${sliderScrollbar}`,
			} : false,
			breakpoints: {
				320: {
					slidesPerView: 'auto',
				},
				640: {
					slidesPerView: 'auto',
				},
				860: {
					slidesPerView: 'auto',
				}
			}
		});

		swiperSlider.on('slideChangeTransitionStart', () => {
			let currentSlide = swiperSlider.realIndex;
			let nextSlide = swiperSlider.realIndex + 1;

			if (currentSlide === nextSlide) {
				return;
			}

			if (currentSlide === 0 && nextSlide === slidesCount - 1) {
				$slider.addClass('slick-first-last');
			} else if (currentSlide === slidesCount - 1 && nextSlide === 0) {
				$slider.addClass('slick-last-first');
			}
		})
			.on('slideChangeTransitionEnd', () => {
				$slider.removeClass('slick-first-last slick-last-first slick-transform');
			});
	});

	$('.slick-slide').on('click', (e) => {
		e.preventDefault();
		let slideIndex = $(e.currentTarget).index();
		$(e.currentTarget).closest('.slick-slider').slickGoTo(parseInt(slideIndex, 10));
	});
}
